import * as Sentry from "@sentry/react";
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import './index.css';
import AppRoutes from "./AppRoutes.tsx";
import App from "./App.tsx";

if (import.meta.env.PROD) {
    Sentry.init({
        dsn: "https://7002ba09b5557c5f4c934c9b5eb04c00@o4509017303678976.ingest.us.sentry.io/4509017305841664",
        integrations: []
    });
}

const queryClient = new QueryClient();
const isVsCode = import.meta.env.VITE_IS_VSCODE_BUILD;
ReactDOM.createRoot(document.getElementById('root')!, {
    onUncaughtError: import.meta.env.PROD ? Sentry.reactErrorHandler((error, errorInfo) => {
        console.warn('Uncaught error', error, errorInfo.componentStack);
    }) : undefined,
    onCaughtError: import.meta.env.PROD ? Sentry.reactErrorHandler() : undefined,
    onRecoverableError: import.meta.env.PROD ? Sentry.reactErrorHandler() : undefined,
}).render(
    <React.StrictMode>
        <QueryClientProvider client={queryClient}>
            {isVsCode ? (
                <App />
            ) : (
                <BrowserRouter>
                    <AppRoutes />
                </BrowserRouter>
            )}
        </QueryClientProvider>
    </React.StrictMode>,
);
